import { render, staticRenderFns } from "./SalesCart.vue?vue&type=template&id=52b97830&scoped=true&lang=pug&"
import script from "./SalesCart.vue?vue&type=script&lang=js&"
export * from "./SalesCart.vue?vue&type=script&lang=js&"
import style0 from "./SalesCart.vue?vue&type=style&index=0&id=52b97830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b97830",
  null
  
)

component.options.__file = "SalesCart.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
installComponents(component, {
  VDivider,
})
